import { render, staticRenderFns } from "./homeworkPic.vue?vue&type=template&id=2c2b4eca&scoped=true&"
import script from "./homeworkPic.vue?vue&type=script&lang=js&"
export * from "./homeworkPic.vue?vue&type=script&lang=js&"
import style0 from "./homeworkPic.vue?vue&type=style&index=0&id=2c2b4eca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2b4eca",
  null
  
)

export default component.exports